import StateControllerBase from "@/store/stateControllerBase";
import { setLoadingState } from "@/store/setLoadingState";

import ItParkController from "@/api/itParkController";

const itParkController = new ItParkController();

class Actions extends StateControllerBase {
  setDataLoading({ commit }, dataLoading) {
    commit("setDataLoading", dataLoading);
  }

  @setLoadingState
  async publishItPark(_context, parkId) {
    return await itParkController.publishItPark(parkId);
  }

  @setLoadingState
  async uploadItPark(_context, park) {
    return await itParkController.uploadItPark(park);
  }

  @setLoadingState
  async deleteItPark({ dispatch }, id) {
    await itParkController.deleteItPark(id);
    await dispatch("getItParks");
  }

  @setLoadingState
  async getItPark({ commit }, id) {
    const data = await itParkController.getItPark(id);
    commit("setItPark", data);
  }

  @setLoadingState
  async clearItPark({ commit }) {
    commit("setItPark", null);
  }

  @setLoadingState
  async getItParks({ commit }) {
    const data = await itParkController.getItParks();
    commit("setItParks", data);
  }
}

export default (new Actions).asPlainObject();